import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-paymera-logo',
  standalone: true,
  templateUrl: '../../assets/paymera-logo.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPaymeraLogoIcon {}
